export const runtimeEnv = {
  APIURL: (window as any).__env?.APIURL || '',
  URLWEB: (window as any).__env?.URLWEB || '',
  BASEURLPINGID: (window as any).__env?.BASEURLPINGID || '',
  MINDATE: (window as any).__env?.MINDATE || '',
  PIXPHONEREGEX: (window as any).__env?.PIXPHONEREGEX || '',
  PIXPHONEMASK: (window as any).__env?.PIXPHONEMASK || '',
  PIXPHONEHINT: (window as any).__env?.PIXPHONEHINT || '',
  PIXPHONEPREFIX: (window as any).__env?.PIXPHONEPREFIX || '',
  PIXSTATUSINTERVAL: (window as any).__env?.PIXSTATUSINTERVAL || '',
  PIXSTATUSMAXATTEMPTS: (window as any).__env?.PIXSTATUSMAXATTEMPTS || '',
  ENCRYPTKEY: (window as any).__env?.ENCRYPTKEY || '',
  RESEND2FA: (window as any).__env?.RESEND2FA || '',
  SESSIONEXPIRATIONTIME: (window as any).__env?.SESSIONEXPIRATIONTIME || '',
  THROTTLEDREFRESHBALANCE: (window as any).__env?.THROTTLEDREFRESHBALANCE || '',
  GOOGLEMAPSKEY: (window as any).__env?.GOOGLEMAPSKEY || '',
  ONESIGNALAPPI: (window as any).__env?.ONESIGNALAPPI || '',
  PRODUCTION: (window as any).__env?.PRODUCTION || ''
};
